
import { useState } from 'react';
import Email from '../component/OTPCom/Email';
import OTPInput from '../component/OTPCom/OTPInput';
import CreatePassword from '../component/OTPCom/CreatePassword';

function OTP({type,handleClick}) {
    const [email, setEmail] = useState('');
    return (
        <div className="">
            {type === 'email' ?
                <Email email={email} setEmail={setEmail} handleClick={handleClick} /> :
                type === 'OTPInput' ?
                <OTPInput email={email} type={type} handleClick={handleClick}/>
                :
                <CreatePassword email={email} handleClick={handleClick}/>
            }
        </div>
    );
}

export default OTP;